export function useOpenWin(){

  const winVisible=ref(false);
  const windowWidth=ref(600);
  const windowHeight=ref(400);
  const windowUrl=ref('');
  const windowTitle=ref('');

  /**
   * 需要显示成link的列
   */
  const openLink=function ({openType,linkUrl,winWidth,winHeight,winTitle}){
    if(openType==='router'){
      window.appObj.$router.push({path:linkUrl});
    }
    if(openType==='window'){
      window.open(linkUrl);
    }
    if(openType==='win'){
      winVisible.value=true;
      windowWidth.value=parseFloat(winWidth);
      windowHeight.value=parseFloat(winHeight);
      windowUrl.value=linkUrl;
      windowTitle.value=winTitle;
    }
  }

  return {
    windowTitle,
    windowWidth,
    windowHeight,
    windowUrl,
    winVisible,
    openLink,
  }
}
